export default __webpack_public_path__ + "eefc162e430857356d69ef1fbf524c1d.svg";